import React, { Fragment, useState, useRef, useEffect } from "react"
import { accessRole } from "../../../../../helpers/access_role"
import apiResponse from "../../../../../services/apiResponse"
import { Link } from "react-router-dom"

import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button, Input, Label,
} from "reactstrap"

import Select from "../../../../../helpers/ui/CustomSelect"

import IndexBloc from './Blocs/IndexBloc'
import TableActiveComponent from './Components/TableActiveComponent'
import moment from "moment"
import DatePicker from "../../../../../helpers/ui/DatePicker"

const FILTER_STORAGE_KEY = 'historyHomeKepegawaianCutiIndexFilter'

const getStoredFilter = () => {
    try {
        const raw = sessionStorage.getItem(FILTER_STORAGE_KEY)
        return raw ? JSON.parse(raw) : null
    } catch (error) {
        return null
    }
}

const statusCuti = [
    { value: -1, label: 'Menunggu Proses Persetujuan Atasan' },
    { value: 0, label: 'Menunggu Proses Persetujuan Admin' },
    { value: 1, label: 'Disetujui' },
    { value: 2, label: 'Ditolak' },
    { value: 3, label: 'Dalam Proses Pembatalan' },
    { value: 4, label: 'Cuti Dibatalkan' },
]

const IndexView = (props) => {

    let indexBloc = new IndexBloc();
    
    const [nip, setNip] = useState('')
    const [name, setName] = useState('')

    const [optionUnits, setOptionUnits] = useState([]);
    const [optionTypes, setOptionTypes] = useState([]);
    const [optionEmployeeStatuss, setOptionEmployeeStatus] = useState([]);
    const [selectedUnit, setSelectedUnit] = useState("")
    const [selectedStatus, setSelectedStatus] = useState("2920a911-9b3f-42cf-ad91-d05cb4ab057b")
    const [filter, setFilter] = useState(() => getStoredFilter()?.filter)
    const [dateStart, setDateStart] = useState(() => getStoredFilter()?.dateStart || moment().startOf('month').format('YYYY-MM-DD'))
    const [dateEnd, setDateEnd] = useState(() => getStoredFilter()?.dateEnd || moment().endOf('month').format('YYYY-MM-DD'))
    const [status, setStatus] = useState(() => getStoredFilter()?.status ?? null)
    const [cutiType, setCutiType] = useState(() => getStoredFilter()?.cutiType ?? null)


    const activeRef = useRef();
    const inactiveRef = useRef();
    const rekapRef = useRef();

    
    const reloadActiveRef = () => activeRef.current.setTokenAPI()
    const reloadInactiveRef = () => inactiveRef.current.setTokenAPI()
    const reloadRekap = () => activeRef.current.setTokenAPIRekap()

    const persistFilter = (newFilter) => {
        try {
            sessionStorage.setItem(FILTER_STORAGE_KEY, JSON.stringify({
                dateStart,
                dateEnd,
                status,
                cutiType,
                filter: newFilter
            }))
        } catch (error) {}
    }

    const handleButtonSearch = () => {
        if (dateStart && dateEnd) {
            const newFilter = {
                'dateStart': dateStart,
                'dateEnd': dateEnd,
                'status': status,
                'paid_leave_type_uuid': cutiType || ""
            }
            setFilter(newFilter)
            persistFilter(newFilter)
            setTimeout(() => {
                reloadActiveRef()
            }, 300);
        } else if (status) {
            const newFilter = {
                'status': status
            }
            setFilter(newFilter)
            persistFilter(newFilter)
            setTimeout(() => {
                reloadActiveRef()
            }, 300);
        }
    }
    const handleButtonRekap = () => {
        if (dateStart && dateEnd) {
            const newFilter = {
                'dateStart': dateStart,
                'dateEnd': dateEnd,
                'status': status,
                'paid_leave_type_uuid': cutiType || ""
            }
            setFilter(newFilter)
            persistFilter(newFilter)
            setTimeout(() => {
                reloadRekap()
            }, 300);
        } else if (status) {
            const newFilter = {
                'status': status
            }
            setFilter(newFilter)
            persistFilter(newFilter)
            setTimeout(() => {
                reloadRekap()
            }, 300);
        }
    }

    useEffect(() => {
        
        indexBloc.typeChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    let type = result.data.response.result
                    setOptionTypes(type)
                    break;
                case apiResponse.ERROR:
                    break;
                default:
                    break;
            }
        })

        indexBloc.fetchTypeList({})

        return () => {
            indexBloc.typeChannel?.unsubscribe()
        }
    }, [])

    return (
        <Fragment>
            <Container fluid>
                <Card>
                    <CardBody>
                        <div className="float-end">
                        {
                            (accessRole('read')) ?
                                <Link to="?list_pegawai">
                                    <Button color="primary">Daftar Pegawai</Button>
                                </Link>
                            : null
                        }
                        </div>
                        <CardTitle>List Cuti</CardTitle>
                        <CardSubtitle className="mb-3">
                            Daftar Cuti
                        </CardSubtitle>
                        <hr />
                        <Row className="mb-3">
                            <Label className="col-md-3 col-form-label">
                                Filter Tanggal Mulai
                            </Label>
                            <Col md="3">
                                {/* <Input placeholder="Tanggal Mulai" type="date" onChange={e => setDateStart(e.target.value)} value={dateStart} /> */}
                                <DatePicker 
                                    name="start_date"
                                    isWeekday={false}
                                    dateFormat="dd/MM/yyyy"
                                    placeholder="Tanggal Mulai"
                                    isAvForm={false}
                                    onChange={val => setDateStart(moment(val).format('YYYY-MM-DD'))}
                                    defaultValue={dateStart}
                                />
                            </Col>
                        </Row>
                        <Row className="mb-3">
                            <Label className="col-md-3 col-form-label">
                                Filter Tanggal Selesai
                            </Label>
                            <Col md="3">
                                {/* <Input placeholder="Tanggal Selesai" type="date" onChange={e => setDateEnd(e.target.value)} value={dateEnd} /> */}
                                <DatePicker 
                                    name="end_date"
                                    isWeekday={false}
                                    dateFormat="dd/MM/yyyy"
                                    placeholder="Tanggal Selesai"
                                    isAvForm={false}
                                    onChange={val => setDateEnd(moment(val).format('YYYY-MM-DD'))}
                                    defaultValue={dateEnd}
                                />
                            </Col>
                        </Row>
                        <Row className="mb-3">
                            <Label className="col-md-3 col-form-label">
                                Jenis Cuti
                            </Label>
                            <Col md="3">
                                <Select 
                                    options={optionTypes} 
                                    isAvForm={false} 
                                    isClearable={true} 
                                    optionLabel="paid_leave_type_name"
                                    optionValue="paid_leave_type_uuid"
                                    defaultValue={cutiType}
                                    onChange={opt => setCutiType(opt ? opt.paid_leave_type_uuid : null)} 
                                />
                            </Col>
                        </Row>    
                        <Row className="mb-3">
                            <Label className="col-md-3 col-form-label">
                                Status Cuti
                            </Label>
                            <Col md="3">
                                <Select options={statusCuti} isAvForm={false} isClearable={true} defaultValue={status} onChange={opt => setStatus(opt ? opt.value : null)} />
                            </Col>
                        </Row>    
                        <Row className="mb-3">
                            <Col md="3"></Col>
                            <Col md="10">
                                <Button 
                                    color="primary" 
                                    type="button"
                                    onClick={() => {
                                        handleButtonSearch()
                                    }}
                                >
                                    <i className="uil-search-alt"></i> Cari
                                </Button>
                            </Col>
                        </Row>
                        <hr />
                        
                        <div className="d-flex mb-3">
                            <div className="ms-auto">
                                <Button 
                                    color="warning" 
                                    type="button"
                                    onClick={() => {
                                        handleButtonRekap()
                                    }}
                                >
                                    <i className="uil-file-download"></i> Rekap Cuti
                                </Button>
                            </div>
                        </div>

                        <hr/>
                        <TableActiveComponent ref={activeRef} handleInactiveSuccess={reloadInactiveRef} rekap={reloadRekap} filter={filter}/>
                    </CardBody>
                </Card>
            </Container>
        </Fragment>
    )

}

export default IndexView